var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],ref:"input",class:_vm.classes,attrs:{"type":"tel","placeholder":"DD/MM/YYYY","disabled":_vm.disabled},domProps:{"value":_vm.valueFormmatted},on:{"change":function($event){return _vm.updateValue($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }